<template>
  <div class="flowchart-with-content">
    <Flowchart
      class="flowchart"
      :type="type"
      :json="json"
    />
    <FlowContent
      class="content"
      :type="type"
      :json="json"
    />
  </div>
</template>

<script>
import Flowchart from './Flowchart'
import FlowContent from './FlowContent'

export default {
  name: 'FlowchartWithContent',
  components: {
    Flowchart,
    FlowContent
  },
  props: {
    type: {
      type: String,
      required: true
    },
    json: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .flowchart-with-content {
    @media (max-width: 1380px) {
      display: flex;

      &:after {
        clear: both;
        content: '';
      }
    }
  }
  .flowchart {
    height: 128px;
    transition: width .8s cubic-bezier(.19,1,.22,1);

    @media (max-width: 1380px) {
      width: 210px;
      float:left;
      height: auto;
      min-height: calc(100vh - $header-height);
      overflow-x: hidden;
      overflow-y: auto;
    }
    @media (max-width: 600px) {
      width: 76px;
    }
    @media (max-width: 479px) {
      min-height: calc(100vh - $header-height-mobile);
    }
  }
  .content {
    min-height: calc(100vh - 128px - $header-height);
    transition: width .8s cubic-bezier(.19,1,.22,1);

    @media (max-width: 1380px) {
      min-height: calc(100vh - $header-height);
      width: calc(100% - 210px);
      float:left;
    }
    @media (max-width: 600px) {
      width: calc(100% - 76px);
    }
    @media (max-width: 479px) {
      min-height: calc(100vh - $header-height-mobile);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Flow/components/FlowchartWithContent.vue